// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__R14VH","footer":"ModalFilter_footer__19MF6"};